import Link from 'next/link';
import React from 'react';
import { GameIcon } from '../icons/GameIcon';
import { PictureWithFallback } from '../sections/PictureWithFallback';
import { MessageIcon } from '../svg/MessageIcon';
import { SocialUserInfo } from './profile-views/ProfileViews';

type Props = {
    socialUserInfo: SocialUserInfo;
    hasGraduatingClass?: boolean;
    onFollowClicked: () => void;
};

export const SocialUserCard: React.FC<Props> = ({ socialUserInfo, hasGraduatingClass, onFollowClicked }) => {
    const followButtonLabel = socialUserInfo.following ? 'Unfollow' : 'Follow';
    return (
        <div className="social-user-card">
            <div className="image-wrapper">
                <PictureWithFallback
                    width={40}
                    height={40}
                    icon={socialUserInfo.deletedUser ? null : socialUserInfo.picture}
                    alt={`${socialUserInfo.deletedUser ? 'Deleted User' : socialUserInfo.label}'s picture`}
                />
            </div>
            <div className="user-info">
                {!socialUserInfo.deletedUser && (
                    <Link href={socialUserInfo.slug}>
                        <a className="user-label">
                            {socialUserInfo.label}
                            {hasGraduatingClass && (
                                <span className="graduating-class">{` '${socialUserInfo.graduating_class
                                    .toString()
                                    .substring(2)}`}</span>
                            )}
                        </a>
                    </Link>
                )}
                {socialUserInfo.deletedUser && <span className="user-label">Deleted User</span>}
                {!socialUserInfo.deletedUser && (
                    <div className="user-sublabel-container">
                        {socialUserInfo.game && (
                            <GameIcon game={socialUserInfo.game.game_definition} gameName={socialUserInfo.game.name} />
                        )}
                        <p className="user-sublabel">{socialUserInfo.subLabel}</p>
                    </div>
                )}
            </div>
            <div className="user-controls">
                {!socialUserInfo.deletedUser && (
                    <>
                        <Link href={`/dashboard/messages/${socialUserInfo.messageSlug}`}>
                            <a className="button circle-button">
                                <MessageIcon />
                            </a>
                        </Link>
                        <button
                            className={`button small-button${
                                socialUserInfo.following ? ' red-button' : ' blue-button'
                            }`}
                            onClick={onFollowClicked}
                        >
                            {socialUserInfo.fakeUser ? 'Upgrade' : followButtonLabel}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};
